import { BookingTimeStatus } from "../../hooks/useBookingTimeGuard";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { useLanguage } from "../../i18n/LanguageContext";

type BookingTimeoutDialogProps = {
  isOpen: boolean;
  type: Exclude<BookingTimeStatus, "ok">;
  onClose: () => void;
};

const BookingTimeoutDialog = ({
  isOpen,
  type,
  onClose,
}: BookingTimeoutDialogProps) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  const bookingClosedText = {
    title: t("quathoigiandangky"),
    description: t("quathoigiandangkymota"),
    note: t("vuilongquaylaitu"),
    time: t("sangmai"),
    button: t("dahieu"),
    alt: t("quathoigiandangky"),
  };

  const bookingNotOpenText = {
    title: t("chuadenthoigiandangky"),
    description: t("chuadenthoigiandangkymota"),
    note: t("vuilongquaylaitu"),
    time: t("sanghomnay"),
    button: t("dahieu"),
    alt: t("chuadenthoigiandangky"),
  };

  const dialogText =
    type === "not-open" ? bookingNotOpenText : bookingClosedText;

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        showCloseButton={false}
        aria-describedby="subcribe"
        className="w-[90%] max-w-[550px] overflow-hidden rounded-lg bg-white shadow-2xl animate-in fade-in zoom-in duration-300"
      >
        <DialogHeader className="sr-only">
          <DialogTitle>{"Chọn hình thức đặt khám"}</DialogTitle>
          <DialogDescription>
            Hộp thoại chọn phương thức đặt khám
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center p-1 text-center">
          <div className="mb-4 flex justify-center">
            <img
              src="/icons/calendar-green.png"
              alt={dialogText.alt}
              className="h-24 w-32 object-contain md:h-32 md:w-36"
            />
          </div>

          <h2 className="mb-3 text-lg font-bold leading-tight text-[#0b2447] md:text-xl">
            {dialogText.title}
          </h2>

          <div className="space-y-3 text-sm leading-relaxed text-gray-600">
            <p>{dialogText.description}</p>
            <p>
              {dialogText.note} <br />
              <span className="font-bold text-primary">{dialogText.time}</span>.
            </p>
          </div>
        </div>

        <div className="flex justify-center pt-0">
          <button
            type="button"
            onClick={onClose}
            className="rounded-full bg-primary px-12 py-2.5 font-semibold text-white shadow-md transition-all duration-200 hover:bg-primary/90 active:scale-95"
          >
            {dialogText.button}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingTimeoutDialog;
